module.exports = __webpack_public_path__ + "img/parser.dd0cabcd.svg";